import { useTranslation } from 'react-i18next';
import ButtonList from '../ButtonList';
import { useRef } from 'react';
import { useRestContext } from 'components/form/RestInputContext';
import CancelModal from '../ModalConfirm/CancelModal';
import { useParams } from 'react-router-dom';
import PassQCModal from '../ModalConfirm/PassQCModal';
import { Card } from 'antd';

export default function FailedQCScreen() {
  const { t } = useTranslation();
  const refModal = useRef<{ open: () => void }>();
  const refCancelModal = useRef<{ open: () => void }>();
  const params = useParams();
  const { record } = useRestContext();

  return (
    <>
      <Card title="QA/QC">
        <ButtonList
          btnCancelText={t('common.button.cancel')}
          btnOkText={t('common.button.passQC')}
          onOk={() => refModal.current.open()}
          onCancel={() => refCancelModal.current.open()}
          hiddenCancelButton={record?.isMarketPlace}
          hiddenOKButton={
            record?.isMarketPlace &&
            record?.order?.statusOms !== 'DELIVERY_SUCCESS'
          }
        />
      </Card>
      <PassQCModal id={record?.id || params?.id} ref={refModal} />
      <CancelModal
        id={record?.id || params?.id}
        ref={refCancelModal}
        initValue={{
          cancelReason: record?.cancelReason,
        }}
      />
    </>
  );
}
